// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/starRating.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/starRating.tsx");
  import.meta.hot.lastModified = "1721051405473.4744";
}
// REMIX HMR END

import React, { useState } from "react";
import { IconMoodCry, IconMoodSad, IconMoodSmile, IconMoodHappy, IconMoodCrazyHappy } from '@tabler/icons-react';
const StarRating = ({
  name,
  dataForm,
  setDataForm
}) => {
  _s();
  const [rating, setRating] = useState(null);
  const [hover, setHover] = useState(null);
  return <div className="flex justify-center md:justify-end flex-grow align-center">
            <div className="inline-grid grid-cols-5 gap-1 w-[225px]">
                <label>
                    <input type="radio" name={name} hidden value={1} checked={dataForm[name] === 1} onClick={() => setDataForm({
          ...dataForm,
          [name]: 1
        })} />
                    <IconMoodCry className="star cursor-pointer" size={40} color={1 === hover ? "#de782d" : 1 <= dataForm[name] ? "#083d78" : "#d1d5db"} onMouseEnter={() => setHover(1)} onMouseLeave={() => setHover(null)} />

                    {/* "#de782d" : "#083d78" */}
                </label>
                <label>
                    <input type="radio" name={name} hidden value={2} checked={dataForm[name] === 2} onClick={() => setDataForm({
          ...dataForm,
          [name]: 2
        })} />
                    <IconMoodSad className="star cursor-pointer" size={40} color={2 === hover ? "#de782d" : 2 <= dataForm[name] ? "#083d78" : "#d1d5db"} onMouseEnter={() => setHover(2)} onMouseLeave={() => setHover(null)} />
                </label>
                <label>
                    <input type="radio" name={name} hidden value={3} checked={dataForm[name] === 3} onClick={() => setDataForm({
          ...dataForm,
          [name]: 3
        })} />
                    <IconMoodSmile className="star cursor-pointer" size={40} color={3 === hover ? "#de782d" : 3 <= dataForm[name] ? "#083d78" : "#d1d5db"} onMouseEnter={() => setHover(3)} onMouseLeave={() => setHover(null)} />
                </label>
                <label>
                    <input type="radio" name={name} hidden value={4} checked={dataForm[name] === 4} onClick={() => setDataForm({
          ...dataForm,
          [name]: 4
        })} />
                    <IconMoodHappy className="star cursor-pointer" size={40} color={4 === hover ? "#de782d" : 4 <= dataForm[name] ? "#083d78" : "#d1d5db"} onMouseEnter={() => setHover(4)} onMouseLeave={() => setHover(null)} />
                </label>
                <label>
                    <input type="radio" name={name} hidden value={5} checked={dataForm[name] === 5} onClick={() => setDataForm({
          ...dataForm,
          [name]: 5
        })} />
                    <IconMoodCrazyHappy className="star cursor-pointer" size={40} color={5 === hover ? "#de782d" : 5 <= dataForm[name] ? "#083d78" : "#d1d5db"} onMouseEnter={() => setHover(5)} onMouseLeave={() => setHover(null)} />
                </label>
            </div>

        </div>;
};
_s(StarRating, "Kld2vfmBym19ZexDnzXMySTOJk8=");
_c = StarRating;
export default StarRating;
var _c;
$RefreshReg$(_c, "StarRating");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;